/* tslint:disable */

declare var Object: any;
export interface RegisterOnboardingInterface {
  "id"?: number;
}

export class RegisterOnboarding implements RegisterOnboardingInterface {
  "id": number;
  constructor(data?: RegisterOnboardingInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `RegisterOnboarding`.
   */
  public static getModelName() {
    return "RegisterOnboarding";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of RegisterOnboarding for dynamic purposes.
  **/
  public static factory(data: RegisterOnboardingInterface): RegisterOnboarding{
    return new RegisterOnboarding(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'RegisterOnboarding',
      plural: 'RegisterOnboardings',
      path: 'RegisterOnboardings',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/RegisterOnboarding.ts